import axios from './axios';

export default {
    getInvoices( filter = null ) {
        const options = {
            method: 'GET',
            url: 'invoicer2/',
            headers: { 'content-type': 'application/json' }
        };

        filter && ( options.params = filter );

        return new Promise( ( resolve, reject ) => {
            axios( options )
                .then( response => {
                    resolve( response.data );
                } )
                .catch( error => {
                    reject( error.message );
                } ) 
        } );
    }
}